import { Directive, ElementRef, Renderer2, Input, Output, EventEmitter } from '@angular/core';
import { UtilitiesService } from '../../../services/utilities.service';

@Directive({ selector: '[scrollBotContainerDirective]' })

export class ScrollBotContainerDirective {

    private DOMObserver: any;

    private el_cvContainer;

    private el_contextScroll;

    @Input('contextual') contextual: boolean = false;

    // @Output() public notReadMsgsEmmiter: EventEmitter<number> = new EventEmitter();
    // (notReadMsgsEmmiter)="notReadMsgsEmmiter($event)"
    
    constructor(
        private elRef: ElementRef,
        private ren: Renderer2,
        private uTS: UtilitiesService
    ) {
        this.DOMObserver = new MutationObserver(mutations => {

            // Executa sempre que detectar alguma mudanca no elemento/
            mutations.forEach(mutation => {
                setTimeout(() => {
                    this.checkMutation(mutation);
                }, 300);
            });
        });
    }

    ngOnInit() {
        // Recupera o elemento "conversation-container" aonde sera renderizado as novas menssagens
        this.el_cvContainer = this.elRef.nativeElement.querySelector('#conversation-container');

        // Recupera o elemento para o scroll contextual
        this.el_contextScroll = this.elRef.nativeElement.querySelector('#conversation-scroll');
        if (this.contextual) {
            this.ren.addClass( this.el_contextScroll, 'contextual');
        } else {
            this.ren.removeClass( this.el_contextScroll, 'contextual');
        }

        // Start DOM observer
        this.DOMObserver.observe(this.el_cvContainer, { childList: true });
    }

    /**
     * Recebe o alteracao que ocorreu no dom,
     * para saber qual tipo de scroll ira usar
     * 
     * @param mutation [modificacao que ocorreu no dom]
     */
    checkMutation(mutation) {
        Array.from(mutation.addedNodes).map((elMutatation: any) => {

            // checa o height do contexto / Scroll container || Window
            let contextHeight = (this.contextual) ? this.el_contextScroll.clientHeight : document.documentElement.clientHeight;

            // checa se o tamanho da mensagem é maior que o contexto
            let height = Math.floor((elMutatation.firstChild.offsetHeight / contextHeight) * 100) >= 93;

            if (height) {
                this.personalScroll(elMutatation);
            }
            else {
                this.fullScroll();
            }
        });
    }

    /**
     * Scroll ate o final
     */
    fullScroll() {
        if (this.contextual) {
            this.uTS.elementScrollTo(this.el_contextScroll, this.el_cvContainer.scrollHeight, 1700);
        }
        else {
            this.uTS.windowScrollTo(this.el_cvContainer.scrollHeight, 500, 'easeInQuad');
        }
    }

    /**
     * Scroll até o inicio do conteudo
     */
    personalScroll(elMutatation) {
        if (this.contextual) {
            this.uTS.elementScrollTo(this.el_contextScroll, elMutatation.offsetTop, 1700);
        }
        else {
            this.uTS.windowScrollTo($(elMutatation).offset().top, 800, 'easeInQuad');
        }
        //this.feedbackMoreScroll();
    }

    /**
     * Caso a msg seja maior que o escopo aonde esta sendo exibida
     * 
     * para deixar de ser exibida, basta clicar ou realizar um scroll dentro do contexto
     */
    feedbackMoreScroll() {
        setTimeout(() => {

            this.ren.addClass(this.el_cvContainer, 'more-messages');

            let scrollController = true;
            let scrollEvent;

            /**
             * Event scroll, observa o window ou um elemento
             * dependendo do contexto passado esperando um scroll
             */
            if (this.contextual) {
                scrollEvent = this.ren.listen(this.el_contextScroll, 'scroll', () => {
                    if (scrollController) {
                        scrollController = false;
                        setTimeout(() => {
                            this.ren.removeClass(this.el_cvContainer, 'more-messages');
                            scrollEvent();
                            clickEvent();
                        }, 1000);
                    }
                });
            }
            else {
                scrollEvent = this.ren.listen('window', 'scroll', () => {
                    if (scrollController) {
                        scrollController = false;
                        setTimeout(() => {
                            this.ren.removeClass(this.el_cvContainer, 'more-messages');
                            scrollEvent();
                            clickEvent();
                        }, 1000);
                    }
                });
            }

            /**
             * Event click, 
             * observa o botão, caso clicado executa um scroll
             */
            let clickEvent = this.ren.listen(this.elRef.nativeElement.querySelector('#more-messages-link'), 'click', ($e) => {
                $e.preventDefault();
                this.fullScroll();
                this.ren.removeClass(this.el_cvContainer, 'more-messages');
                scrollEvent();
                clickEvent();
            });

        }, 2800);
    }

    ngOnDestroy() {
        this.DOMObserver.disconnect();
    }
}